import { Footer, Header, SEO } from "@/components";
import {
  AiBlog,
  AiUseCases,
  FinalCta,
  HeroSection,
  HowWeBuildAiSystems,
  HumanFirstAiPhilosophy,
  Industries,
  NivaProduct,
  WhatWeBuild,
} from "@/components/main";
import DeliverySignals from "@/components/main/deliverySignals";
import WhoWeHelp from "@/components/main/whoWeHelp";
import WhyFit from "@/components/main/whyFit";
import HomeFaq, { HOME_FAQS } from "@/components/main/homeFaq";
import NextSteps from "@/components/main/nextSteps";
import SEOConfig, { SITE } from "@/common/seo.config";
import { fetchBlogList } from "@/lib/blogs";
import { HOME_BLOG_LIMIT } from "@/components/main/aiBlog";
import {
  buildFaqPage,
  buildItemListSchema,
  buildWebPage,
  pageSchemas,
} from "@/lib/schema";

const HOME_SERVICES = [
  { name: "AI Agent Development", path: "/ai-agent-development" },
  {
    name: "Custom LLM Applications",
    path: "/custom-llm-application-development",
  },
  { name: "AI MVP and PoC Development", path: "/mvp-poc-development" },
  { name: "AI Workflow Automation", path: "/ai-workflow-automation" },
  { name: "AI Integrations", path: "/ai-integrations" },
];

export default function Home({ posts = [] }) {
  const structuredData = pageSchemas([
    buildWebPage({
      path: "/",
      name: SEOConfig.home.pageTitle,
      description: SEOConfig.home.pageDescription,
    }),
    buildItemListSchema({
      name: "Nivalabs AI services",
      path: "/",
      items: HOME_SERVICES,
    }),
    buildFaqPage(HOME_FAQS, { id: `${SITE.siteUrl}/#faq` }),
  ]);

  return (
    <>
      <SEO {...SEOConfig.home} structuredData={structuredData} />

      <Header />
      <main>
        <HeroSection />
        <WhatWeBuild />
        <WhoWeHelp />
        <HowWeBuildAiSystems />
        <NivaProduct />
        <Industries />
        <AiUseCases />
        <WhyFit />
        <HumanFirstAiPhilosophy />
        <DeliverySignals />
        <HomeFaq />
        <NextSteps />
        <FinalCta
          title="Let's build the right system"
          descriptionPrimary="If you have an operational problem that AI might solve, we will help you scope it clearly and decide what is worth building."
          linkText="Talk to an architect"
        />
        <AiBlog posts={posts} />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const posts = await fetchBlogList({ limit: HOME_BLOG_LIMIT });

  return {
    props: { posts },
    revalidate: 300,
  };
}
